import './styles/SizeOption.css';

export default function SizeOption({ data, isSelected, selectOption }) {
  return (
    <>
      {Boolean(data) && (
        <button
          type="button"
          className={`purchase-select-size__option-button font-size-medium purchase-size-option__container${isSelected ? ' selected' : ''}`}
          onClick={selectOption}
        >
          <div className="purchase-size-option__size">
            <span className="purchase-size-option__size-text">
              {data.width} cm x {data.height} cm
            </span>
          </div>

          <span className="purchase-size-option__size-edition-text font-size-small">
            Edition of {data.quantity}
          </span>

          <span className="purchase-size-option__size-text">
            €{data.price}
          </span>
        </button>
      )}
    </>
  );
}
